import { useEffect, useState } from "react";
import styles from "./AddresseManager.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { crearteAddress, getCountries } from "services/api";

const NewAddress = ({ tunnel = true, refresh }) => {


  const [values, setValues] = useState({
    city: '',
    zipCode: '',
    address: '',
    firstname: '',
    lastname: '',
    name: "",
    phone: '',
    email: '',
    country: '',
  });
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);

  const [isCompany, setIsCompany] = useState(false);

  const [Countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    const response = await getCountries();
    if (response.success) {
      setCountries(response.data);
      // Définir la France comme pays par défaut si aucun pays n'est sélectionné
      if (!values.country) {
        setValues(prev => ({ ...prev, country: 'FRA' }));
      }
    } else {
      console.error("Erreur lors de la récupération des pays :", response.errors);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await crearteAddress({
      city: values.city,
      zipCode: values.zipCode,
      address: values.address,
      firstname: values.firstname,
      lastname: values.lastname,
      phone: values.phone,
      name: values.name,
      email: values.email,
      country: values.country,
      siret: values.siret,
      raisonSociale: values.raisonSociale,
      numTva: values.numTva,
    });

    if (!response.success) {
      setErrors(response.errors.errors);
    } else {
      setErrors({});
      setAlert({ type: 'success', message: "Adresse créée avec succès." });
      setTimeout(() => {
        setAlert(null);
      }, 5000);
      refresh();
      setValues({
        city: '',
        zipCode: '',
        address: '',
        firstname: '',
        lastname: '',
        name: "",
        phone: '',
        email: '',
        country: '',
        siret: '',
        raisonSociale: '',
        numTva: '',
      });
    }
    console.log(response);

  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.Title}>Ajouter une nouvelle adresse de facturation</div>
      <p className={styles.Description}>Veuillez remplir ce formulaire pour entrer une nouvelle adresse de facturation</p>
      <form onSubmit={handleSubmit}>
        {alert && (
          <div className={`${styles.alert} ${styles[alert?.type]}`}>
            {alert?.message}
          </div>
        )}
        <ul className={styles.InputsList}>
          <li>
            <input
              type="checkbox"
              name="company"
              id="company"
              value={true}
              onChange={e => {
                setIsCompany(e.target.checked)
                setValues({ ...values, company: e.target.checked })
              }}
            />
            <label htmlFor="company">Cette adresse est pour une entreprise</label>
          </li>
          {
            isCompany && (
              <>

                <li className={styles.rowSplit}>
                  <label htmlFor="raison-sociale">Raison sociale*
                  </label>
                  <input
                    type="text"
                    name="raison-sociale"
                    id="raison-sociale"
                    value={values.raisonSociale}
                    onChange={e => setValues({ ...values, raisonSociale: e.target.value })}
                  />
                  {errors.raisonSociale && <span className={styles.error}>{errors.raisonSociale}</span>}
                </li>
                <li className={styles.rowSplit}>
                  <label htmlFor="siret">Siret*
                  </label>
                  <input
                    type="text"
                    name="siret"
                    id="siret"
                    value={values.siret}
                    onChange={e => setValues({ ...values, siret: e.target.value })}
                  />
                  {errors.siret && <span className={styles.error}>{errors.siret}</span>}
                </li>
                <li>
                  <label htmlFor="numTva">Numéro de TVA*
                  </label>
                  <input
                    type="text"
                    name="numTva"
                    id="numTva"
                    value={values.numTva}
                    onChange={e => setValues({ ...values, numTva: e.target.value })}
                  />
                  {errors.numTva && <span className={styles.error}>{errors.numTva}</span>}
                </li>
              </>)
          }
          <li>
            <label htmlFor="name">Nom de l'adresse*
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={values.name}
              onChange={e => setValues({ ...values, name: e.target.value })}
            />
            {errors.name && <span className={styles.error}>{errors.name}</span>}
          </li>
          <li className={styles.rowSplit}>
            <label htmlFor="firstname">Prénom*
            </label>
            <input
              type="text"
              name="firstname"
              id="firstname"
              value={values.firstname}
              onChange={e => setValues({ ...values, firstname: e.target.value })}
            />
            {errors.firstname && <span className={styles.error}>{errors.firstname}</span>}
          </li>
          <li className={styles.rowSplit}>
            <label htmlFor="lastname">Nom*
            </label>
            <input
              type="text"
              name="lastname"
              id="lastname"
              value={values.lastname}
              onChange={e => setValues({ ...values, lastname: e.target.value })}
            />
            {errors.lastname && <span className={styles.error}>{errors.lastname}</span>}
          </li>
          {/* <li>
            <label htmlFor="email">Email (identifiant)*</label>
            <input
              type="text"
              name="email"
              id="email"
              value={values.email}
              onChange={e => setValues({ ...values, email: e.target.value })}
            />
            {errors.email && <span className={styles.error}>{errors.email}</span>}
          </li> */}
          <li>
            <label htmlFor="phone">Téléphone*
            </label>
            <input
              type="text"
              name="phone"
              id="phone"
              value={values.phone}
              onChange={e => setValues({ ...values, phone: e.target.value })}
            />
            {errors.phone && <span className={styles.error}>{errors.phone}</span>}
          </li>
          <li>
            <label htmlFor="address">Adresse (numéro et voie)*</label>
            <textarea
              type="text"
              name="address"
              id="address"
              value={values.address}
              onChange={e => setValues({ ...values, address: e.target.value })}
            />
            {errors.address && <span className={styles.error}>{errors.address}</span>}
          </li>
          <li className={styles.rowSplit}>
            <label htmlFor="zipcode">Code postal*
            </label>
            <input
              type="text"
              name="zipcode"
              id="zipcode"
              value={values.zipCode}
              onChange={e => setValues({ ...values, zipCode: e.target.value })}
            />
            {errors.zipCode && <span className={styles.error}>{errors.zipCode}</span>}
          </li>
          <li className={styles.rowSplit}>
            <label htmlFor="city">Ville*
            </label>
            <input
              type="text"
              name="city"
              id="city"
              value={values.city}
              onChange={e => setValues({ ...values, city: e.target.value })}
            />
            {errors.city && <span className={styles.error}>{errors.city}</span>}
          </li>
          <li>
            <label htmlFor="country">Pays*
            </label>
            <select
              id="country"
              name="country"
              value={values.country}
              onChange={e => setValues({ ...values, country: e.target.value })}
            >
              <option value="">Sélectionnez un pays</option>
              {Countries && Countries.map(country => (
                <option key={country.alpha3} value={country.alpha3}>
                  {country.name}
                </option>
              ))}
            </select>
            {errors.country && <span className={styles.error}>{errors.country}</span>}
          </li>
        </ul>

        <Button type="submit">Ajouter une nouvelle adresse</Button>
      </form>
    </div>
  );
}

export default NewAddress;
